/* ===========================================================================
   Small meta glyphs.

   These stand in for Font Awesome Pro icons that the reference site loads but
   cannot redistribute; they are drawn here at a matching weight rather than
   pulling in an icon dependency for three shapes.

   The five symbolic icons live in `flatIcons.jsx` / `iconArt.js`.
   =========================================================================== */

export function BookIcon(props) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" fill="none" {...props}>
      <rect
        x="3.2"
        y="2.6"
        width="13.6"
        height="14.8"
        rx="1.8"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M7.4 2.6v6l2.2-1.6 2.2 1.6v-6" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

export function StarIcon(props) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path
        fill="currentColor"
        d="M10 1.6l2.5 5.1 5.6.8-4.1 4 1 5.6-5-2.7-5 2.7 1-5.6-4.1-4 5.6-.8L10 1.6z"
      />
    </svg>
  );
}

export function ArrowIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" {...props}>
      <path
        d="M4 12h15m0 0-6-6m6 6-6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
